(function(){
  // ---- real shape photos (theme assets, same as the search shape filter) ----
  var CFG = window.__spxCfg_diamond4cs || {};
  var SHAPE_IMG = CFG.shapeImg || {};
  var SHAPE_TITLE = { 'round':'Round Brilliant' };

  // Stienhardt sources diamonds and sets them in NYC. A SKU is not evidence
  // that Stienhardt cut or faceted a stone, so the legacy source seal is disabled.
  var SHOW_SEAL = false;
  function isInHouse(){ return false; }

  // ---- grade reference data (US order: lowest LEFT, highest RIGHT) ----
  var DATA = {
    color:{ value:'', grades:['K','J','I','H','G','F','E','D'],
      ranges:[['Faint',['K']],['Near Colorless',['J','I','H','G']],['Colorless',['F','E','D']]] },
    clarity:{ value:'', grades:['SI2','SI1','VS2','VS1','VVS2','VVS1','IF','FL'],
      ranges:[['Slight',['SI2','SI1']],['Very Slight',['VS2','VS1']],['Very Very Slight',['VVS2','VVS1']],['Flawless',['IF','FL']]] },
    cut:{ value:'', grades:['Fair','Good','Very Good','Ideal','Excellent'], ranges:null }
  };
  var CLARITY_BEST=['FL','IF','VVS1','VVS2','VS1','VS2','SI1','SI2']; // index = inclusion count
  var CUT_BEST=['Excellent','Ideal','Very Good','Good','Fair'];
  var TINTS={D:'#FFFFFF',E:'#FEFCF8',F:'#FCF8F1',G:'#FAF3E6',H:'#F6EDD4',I:'#F1E3BD',J:'#ECD9A2',K:'#E6CF87'};

  var colorDesc={
    K:'A faint warmth is visible, especially in larger stones.',
    J:'A slight warmth around the edges; most apparent beside a colorless stone.',
    I:'A hint of warmth around the edges; faces up white in yellow gold.',
    H:'Near-colorless. Faint warmth is hard to detect. Strong choice for yellow gold.',
    G:'Near-colorless. Faces up white in most settings.',
    F:'Colorless. No tint visible to the unaided eye — only detectable in lab conditions.',
    E:'Colorless. Virtually identical to D in appearance.',
    D:'Absolutely colorless — the highest grade. Extremely rare.'
  };
  var clarityDesc={
    SI2:'Inclusions are often visible to the naked eye, particularly near the center.',
    SI1:'Inclusions may be visible to the naked eye depending on position.',
    VS2:'Mostly eye-clean; some inclusions visible only on close inspection.',
    VS1:'Eye-clean. Inclusions are visible only under 10× magnification.',
    VVS2:'Eye-clean. Inclusions are very difficult to find even at 10×.',
    VVS1:'Eye-clean. Inclusions are extremely difficult to detect at 10×.',
    IF:'Internally flawless — no inclusions whatsoever at 10×.',
    FL:'Flawless — no internal or external imperfections of any kind.'
  };
  var cutDesc={
    Fair:'A majority of light entering the diamond escapes.',
    Good:'Reflects most of the light that enters.',
    'Very Good':'Superior fire and brilliance.',
    Ideal:'Cut to maximize brilliance — top tier of cut quality.',
    Excellent:'Maximum brilliance — nearly all light entering returns to the eye.'
  };
  function caratDesc(ct){ var c=parseFloat(ct); if(isNaN(c)) return '';
    if(c<0.75) return 'A delicate, understated weight.';
    if(c<1.10) return 'The classic one-carat presence.';
    if(c<1.75) return 'A noticeable, confident presence.';
    if(c<2.50) return 'A true statement weight.';
    if(c<3.50) return 'A rare and substantial stone.';
    return 'An extraordinary, collector-tier weight.'; }
  function colorSub(g){ for(var i=0;i<DATA.color.ranges.length;i++){ if(DATA.color.ranges[i][1].indexOf(g)!==-1) return DATA.color.ranges[i][0]; } return ''; }
  function claritySub(g){ if(g==='FL'||g==='IF') return 'Flawless'; if(g==='SI1'||g==='SI2') return 'Slightly Included'; return 'Eye-Clean'; }
  function cutSub(g){ return {'Excellent':'Maximum Fire','Ideal':'Exceptional','Very Good':'Brilliant','Good':'Bright','Fair':'Modest'}[g]||''; }

  // ---- grade visuals ----
  function diamondTop(fill,stroke,dots){
    return '<svg viewBox="0 0 30 30"><path d="M15,3 a12,12 0 1,0 0,24 a12,12 0 1,0 0,-24 Z" fill="'+fill+'" stroke="'+(stroke||'rgba(10,29,46,0.45)')+'" stroke-width="0.9"/>'+(dots||'')+'</svg>';
  }
  function cutProfile(quality){
    var n=1+Math.round(quality*2),w=[16,12,8],r='';
    for(var i=0;i<n;i++){ r+='<path d="M'+w[i]+',1 L20,26 L'+(40-w[i])+',1" stroke="#0A1D2E" stroke-width="1" opacity="0.5" stroke-linecap="round" fill="none"/>'; }
    return '<svg viewBox="0 0 40 36" fill="none" style="color:#0A1D2E"><g>'+r+'</g><path d="M12,10 L28,10 L37,16 L20,31 L3,16 Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><g stroke="currentColor" stroke-width="0.8"><path d="M12,10 L3,16 M28,10 L37,16 M3,16 L37,16"/></g></svg>';
  }
  function vizFor(c,grade,idx){
    if(c==='color'){ return '<span class="dp__viz">'+diamondTop(TINTS[grade]||'#fff')+'</span>'; }
    if(c==='clarity'){ var rank=CLARITY_BEST.indexOf(grade),nd=Math.round(rank*0.7),dots='',seed=rank*7+5;
      function rnd(m){seed=(seed*9301+49297)%233280;return Math.abs(seed%m);}
      for(var d=0;d<nd;d++){ dots+='<circle cx="'+(9+rnd(13))+'" cy="'+(9+rnd(13))+'" r="'+(0.7+rnd(6)/10)+'" fill="rgba(10,29,46,0.65)"/>'; }
      return '<span class="dp__viz">'+diamondTop('#fff','rgba(10,29,46,0.4)',dots)+'</span>'; }
    if(c==='cut'){ var r=CUT_BEST.indexOf(grade),q=(CUT_BEST.length-1-r)/(CUT_BEST.length-1); return '<span class="dp__viz cut">'+cutProfile(q)+'</span>'; }
    return '';
  }

  function buildDrawer(c){
    var d=DATA[c],g=d.grades,desc={color:colorDesc,clarity:clarityDesc,cut:cutDesc}[c][d.value]||'',html='';
    html+='<div class="dp__d-title">'+c.charAt(0).toUpperCase()+c.slice(1)+' &mdash; '+(d.value||'')+'</div>';
    html+='<div class="dp__d-desc">'+desc+'</div><div class="dp__scale">';
    for(var i=0;i<g.length;i++){ var on=g[i]===d.value; html+='<span class="dp__scale-item'+(on?' on':'')+'">'+vizFor(c,g[i],i)+'<span class="dp__lab">'+g[i]+'</span></span>'; }
    html+='</div>';
    if(d.ranges){ html+='<div class="dp__ranges">'; d.ranges.forEach(function(r){ var on=r[1].indexOf(d.value)!==-1; html+='<span class="dp__range'+(on?' on':'')+'" style="flex:'+r[1].length+'"><span>'+r[0]+'</span></span>'; }); html+='</div>'; }
    return html;
  }

  // ---- expand / collapse ----
  var drawer=document.getElementById('dp-drawer'), drawerIn=document.getElementById('dp-drawer-in'), openC=null;
  document.querySelectorAll('.dp__cell--btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var c=btn.getAttribute('data-c');
      document.querySelectorAll('.dp__cell').forEach(function(x){ x.classList.remove('is-open'); x.setAttribute('aria-expanded','false'); });
      if(openC===c){ drawer.classList.remove('is-open'); openC=null; return; }
      if(!DATA[c].value){ return; }
      drawerIn.innerHTML=buildDrawer(c); drawer.classList.add('is-open'); btn.classList.add('is-open'); btn.setAttribute('aria-expanded','true'); openC=c;
    });
  });

  // ---- read live diamond data from the PDP ----
  function txt(sel){ var e=document.querySelector(sel); return e?(e.textContent||'').trim():''; }
  function readData(){
    return {
      color:   txt('.diamond-short-information .color-info, .accordion-content .color-info, .color-info'),
      clarity: txt('.diamond-short-information .clarity-info, .accordion-content .clarity-info, .clarity-info'),
      cut:     txt('.diamond-short-information .cut-info, .accordion-content .cut-info, .cut-info'),
      carat:   txt('.diamond-short-information .carat-info, .accordion-content .carat-info, .carat-info'),
      shape:   txt('.diamond-short-information .shape-info, .accordion-content .shape-info, .shape-info'),
      meas:    txt('.measurements-info, .accordion-content .measurements-info'),
      lab:     txt('.certificate-type-info'),
      report:  txt('.sp-stone-cert-stamp__number')
    };
  }
  function setText(id,t){ var e=document.getElementById(id); if(e) e.textContent=(t==null?'':t); }

  var lastSig='';
  function render(){
    var data=readData();
    if(!data.color && !data.clarity && !data.cut) return false;
    var cut=data.cut; if(!cut || CUT_BEST.indexOf(cut)===-1) cut='Excellent';
    var sig=[data.color,data.clarity,cut,data.carat,data.shape,data.meas,data.lab,data.report].join('|');
    if(sig===lastSig) return true;
    lastSig=sig;

    var section=document.getElementById('diamond-4cs');
    if(section) section.style.display='block';

    // hero photo
    var shapeKey=(data.shape||'round').toLowerCase().trim();
    var img=SHAPE_IMG[shapeKey]||SHAPE_IMG['round'];
    var hero=document.getElementById('dp-hero');
    if(hero) hero.innerHTML='<img class="dp__hero-img" alt="'+(data.shape||'Diamond')+'" src="'+img+'">';

    // title
    var shapeName=SHAPE_TITLE[shapeKey]||(data.shape||'Diamond');
    var caratTxt=data.carat? (parseFloat(data.carat).toFixed(2)) : '';
    setText('dp-title', shapeName + (caratTxt? ' · '+caratTxt+' Carat':''));

    // cert line — pull just the lab token (IGI/GIA/GCAL/IGL/HRD) + report digits
    var labM=(data.lab||'').toUpperCase().match(/\b(IGI|GIA|GCAL|IGL|HRD)\b/);
    var lab=labM?labM[1]:'';
    var repNum=(data.report||'').replace(/\D/g,'');
    var cert='';
    if(lab) cert=lab+' Certified';
    if(repNum) cert=(cert?cert+' · ':'')+'Report #'+repNum;
    setText('dp-cert', cert);

    // cells
    setText('dp-carat-value', caratTxt? caratTxt:'—');
    var mm=(data.meas||'').match(/[\d.]+/g);
    setText('dp-carat-sub', (mm && mm.length>=2)? (parseFloat(mm[0]).toFixed(2)+' × '+parseFloat(mm[1]).toFixed(2)+' mm'):'');
    DATA.color.value=data.color; DATA.clarity.value=data.clarity; DATA.cut.value=cut;
    setText('dp-color-value', data.color||'—');   setText('dp-color-sub', colorSub(data.color));
    setText('dp-clarity-value', data.clarity||'—'); setText('dp-clarity-sub', claritySub(data.clarity));
    setText('dp-cut-value', cut);                  setText('dp-cut-sub', cutSub(cut));

    // seal — in-house only
    var seal=document.getElementById('dp-seal');
    if(seal){ if(isInHouse()){ seal.innerHTML=sealSvg(); seal.hidden=false; } else { seal.hidden=true; } }

    // refresh an open drawer
    if(openC){ drawerIn.innerHTML=buildDrawer(openC); }
    return true;
  }

  function sealSvg(){
    return '<svg viewBox="0 0 100 100" fill="none">'
      +'<defs><path id="dp-seal-top" d="M17,50 A33,33 0 0 1 83,50"/><path id="dp-seal-bot" d="M19,50 A31,31 0 0 0 81,50"/></defs>'
      +'<circle cx="50" cy="50" r="47" stroke="currentColor" stroke-width="0.9"/>'
      +'<circle cx="50" cy="50" r="42" stroke="currentColor" stroke-width="0.5" stroke-dasharray="1.4 2.4" opacity="0.7"/>'
      +'<text font-family="Nunito Sans,sans-serif" font-size="8.6" font-weight="700" letter-spacing="2" fill="currentColor" text-anchor="middle"><textPath href="#dp-seal-top" startOffset="50%">STIENHARDT</textPath></text>'
      +'<text font-family="Nunito Sans,sans-serif" font-size="7.4" font-weight="700" letter-spacing="1.6" fill="currentColor" text-anchor="middle"><textPath href="#dp-seal-bot" startOffset="50%"></textPath></text>'
      +'<circle cx="15.5" cy="50" r="0.9" fill="currentColor"/><circle cx="84.5" cy="50" r="0.9" fill="currentColor"/>'
      +'</svg>';
  }

  function start(){
    var tries=0, iv=setInterval(function(){ tries++; render(); if(tries>120) clearInterval(iv); }, 250);
    var mp=document.getElementById('mainproduct');
    if(mp && typeof MutationObserver!=='undefined'){
      new MutationObserver(function(){ render(); }).observe(mp,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['style']});
    }
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',start); } else { start(); }
})();
